import { useCompaniesAutocomplete } from '~/domains/companies/queries/companyAutocomplete'

export const CompanyChipValue = ({ id }: { id: string }) => {
  const { data } = useCompaniesAutocomplete({ ids: [id] })
  const name = data?.pages[0]?.['hydra:member']?.[0]?.name
  return name ?? null
}
